<mat-card appearance="raised" class="gd-edit-user__my-profile gd-global-canvas__margin gd-global-canvas__min-height tw-justify-between" [dir]="dir$ | async">
  <h4 class="gd-edit-user__step-heading"
  i18n>My profile</h4>
  <gd-user-details-form [userForm]="userForm"
    [userEdited]="userEdited">
  </gd-user-details-form>

  <div class="gd-edit-user__action-buttons tw-flex tw-justify-between tw-items-center">
    <button mat-raised-button
      i18n
    (click)="openChangePasswordDialog()">Change Password</button>

    <div class="tw-flex tw-gap-2">
      <button mat-raised-button
        [disabled]="!userForm.valid"
        [color]="userForm.dirty ? 'primary' : ''"
        (click)="submitMyProfile()">
        @if (userForm.dirty) {
          <ng-container
          i18n>Save</ng-container>
        }
        @if (userForm.pristine) {
          <ng-container
          i18n>Cancel</ng-container>
        }
      </button>
    </div>
  </div>
</mat-card>
